import type { ButtonProps as MuiButtonProps } from '@mui/material'

import { CircularProgress, Button as MuiButton } from '@mui/material'

import { Tooltip } from '@/components/ui/tooltip'

export interface ButtonProps extends MuiButtonProps {
  loading?: boolean
  tooltip?: string
}

export function Button({ loading, disabled, startIcon, tooltip, children, ...props }: ButtonProps) {
  const button = (
    <MuiButton
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : startIcon}
      {...props}
      style={{ whiteSpace: 'nowrap' }}
    >
      {children}
    </MuiButton>
  )

  return tooltip ? (
    <Tooltip title={tooltip} compact>
      {button}
    </Tooltip>
  ) : (
    button
  )
}
